import { lightTheme, darkTheme } from 'ggApp/shared/themes';

export const isLightTheme = (theme) => theme === lightTheme;
export const isDarkTheme = (theme) => theme === darkTheme;
